<template>
  <div :class="theme==0?'dark':'white'">
    <userAgreement></userAgreement>
    <Privacypolicy></Privacypolicy>
  </div>
</template>
<script>
  import userAgreement from "@/components/userAgreement.vue";
  import Privacypolicy from "@/components/Privacypolicy.vue";
  export default {
    name: "about",
    components: {
      userAgreement,
      Privacypolicy,
    },
    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      window.scrollTo(0, 0);
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    },
  };

</script>

<style lang="less">
  .contentTerms {}

  * {
    margin: 0;
    padding: 0;
  }



  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* 未被访问的链接 */
  a:visited {
    color: #935171;
  }

  /* 已被访问的链接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠标指针移动到链接上 */
  /* a:active {background:#FF704D;}  正在被点击的链接 */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #bdbdbd;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878b;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul li p {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

  .dark {
    background: #000000;

    .main {
      // background-color: #0C0C0C;
      color: #8d8f9f !important;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    }

  }

  .white {
    background: #ffffff;

    .main {
      // background-color: #f1f1f1;
      color: #333333 !important;
      box-shadow: 0px 1px 2px 0px rgba(226, 226, 226, 0.5);

    }

    .topTitle {
      color: #333333 !important;
    }

    .intro,
    .privacy-content {
      color: #333333 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/termsA.vue